import React from 'react';

export const Contact = ({ color }) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2770_3770)">
      <path
        d="M4.02222 9.48563C5.62222 12.6301 8.2 15.1967 11.3444 16.8079L13.7889 14.3634C14.0889 14.0634 14.5333 13.9634 14.9222 14.0967C16.1667 14.5079 17.5111 14.7301 18.8889 14.7301C19.5 14.7301 20 15.2301 20 15.8412V19.719C20 20.3301 19.5 20.8301 18.8889 20.8301C8.45556 20.8301 0 12.3745 0 1.94119C0 1.33008 0.5 0.830078 1.11111 0.830078H5C5.61111 0.830078 6.11111 1.33008 6.11111 1.94119C6.11111 3.33008 6.33333 4.66341 6.74444 5.90786C6.86667 6.29675 6.77778 6.73008 6.46667 7.04119L4.02222 9.48563Z"
        fill={color ?? '#005EE0'}
      />
    </g>
    <defs>
      <clipPath id="clip0_2770_3770">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.830078)"
        />
      </clipPath>
    </defs>
  </svg>
);
